/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @angular-eslint/component-selector */
import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
@Component({
	selector: 'custom-input',
	templateUrl: './custom-input.component.html',
	styleUrl: './custom-input.component.css',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => CustomInputComponent),
			multi: true,
		},
	],
})
export class CustomInputComponent {
	@Input() label = "";
	@Input() id = "";
	@Input() required = false;
	@Input() type = "text";
	@Input() hasError = false;
	@Input() errors: any = {};
	@Input() customError: any = null;

	value: any = null;
	onChange: any;
	onTouched: any;

	writeValue(value: string): void {
		this.value = value;
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}
}
